<template>
	<div id="sideNav">

		<nav id="mainNav">
			<div class="logo center-cont" v-scroll-to="'#hero'">
				<img src="@/assets/images/logo.png" />
			</div>
			<div class="main-menu" >
				<!-- v-scroll-spy-active v-scroll-spy-link -->
				<ul class="menu-inner" v-scroll-spy-active v-scroll-spy-link >
					<li v-for="(navItem, index) in navItems"
						:key="index" class="menu-item"
						v-scroll-to="navItem.link">
						<a :href="navItem.link" class="item">{{ navItem.menuName }}</a>
					</li>
				</ul>

			</div>
		</nav>
		<!-- <div class="exclusive_btn_section">

			<button type="button" class="exclusive_btn" name="button"  @click="ExlusiveContentActive = true" @click.prevent="(e) => $emit('ExlusiveContentShow', 'show')">View Exclusive Content</button>
		</div> -->


	<!-- </nav> -->
</div>

</template>

<script>
// import { TweenLite } from "gsap/dist/gsap";
import { ref, reactive, watch, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
	name: "SideNav",
	emit: ["ExlusiveContentShow"],
	data() {
		return {
			//RepInfoActive: false,
			ExlusiveContentActive: false,
			navItems: [
				{},
				{
					menuName: "Exclusive Benefits",
					link: "#benefits"
				},
				{
					menuName: "Seat Selection",
					link: "#seat_selection"
				},
				{
					menuName: "Plans & Pricing",
					link: "#account_summary"
				},
				{
					menuName: "Payment Info",
					link: "#paymentInfo"
				},
				// {
				// 	menuName: "IMPORTANT DATES",
				// 	link: "#important_dates"
				// },
				{
					menuName: "FAQ",
					link: "#contact_us"
				},
			],

			openMenu: ""
		};
	},
	setup() {
		const store = useStore();

		// State
		const state = reactive({


		});
		return { ...toRefs(state) };
	},

	mounted() {
		setTimeout(function() {
			window.scrollTo(0, 1);
		}, 500);
	},
	methods: {
		ExlusiveContentHide(){
			this.ExlusiveContentActive  = false;
		},

	},

};
</script>
<style lang="scss" scoped>
.center-cont {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
}
#sideNav {
	.logo {
		position: relative;
		height: 100px;
		@media (max-width: $lg) {
			border: none;
		}
		img {
			width: 100px;
		}
	}
	.quick_link{
		position: relative;
	}
	.video_btn{
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 8px 15px;
		margin: 70px 10px 0px 10px;
		text-decoration:none;
		background: #CC3433;
		border-radius: 55px;
		font-family: 'Verlag Book';
		font-style: normal;
		font-weight: 325;
		font-size: 16px;
		line-height: 19px;

	}
	#mainNav{
		display: flex;
		flex-direction:column;
		justify-content: center;
		align-items: center;
		width: 100%;
		margin-top:10vh;

	}
	//quick_link
	.exclusive_btn_section{
		width:100%;
		//margin: 0 auto;
		position:relative;
		margin-left:30px;
		margin-top: 30px;
		.exclusive_btn{
			background: #CC3433;
			border-radius: 55px;
			padding: 8px 15px;
			border:none;
			color:white;
			font-family: 'Verlag Book';
			font-style: normal;
			font-weight: 325;
			font-size: 16px;
			line-height: 19px;
			text-decoration:none;
		}
	}

	.main-menu{
		margin-top:50px;
		@media (min-width: 999px) and (max-width: 1200px) {
			margin-top:20px;
		}
		.menu-inner{
			padding-left:0px;
		}
		li{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 20px;
			//@media only screen and (-webkit-min-device-pixel-ratio: 2) {
			//   padding: 15px 20px;
			//}
			@media (min-width: 999px) and (max-width: 1200px) {
				padding: 15px 20px;
			}
			&.active{
				background: #CC3433;
				width:230px;
			}
			&:first-child(){
				display:none;
			}
			a{
				color:white !important;
			}
		}

		.item{

			font-family: 'Verlag Light';
			font-style: normal;
			font-weight: 325;
			font-size: 16px;
			line-height: 145%;
			text-decoration:none;
			text-transform: uppercase;
			color: #FFFFFF;
		}
	}
}
</style>
